import { Link } from 'react-router-dom';

export default function Products() {
  const products = [
    {
      id: 'jawline-support-strap',
      name: 'Jawsthe™ NightForm',
      description: 'Support proper jaw positioning during sleep. For men & women.',
      price: 29,
      image: 'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/badb2f3f49cae46b24967f0ed3d3f836.jpeg',
      badge: 'Bestseller',
    },
    {
      id: 'beef-tallow-cream',
      name: 'JawsThe™ PureTallow',
      description: 'Natural moisturizer with tallow & honey. For men & women.',
      price: 34,
      image: 'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/7d5718d63f1bd6b8af2742ac690c7eba.png',
      badge: 'New',
    },
  ];

  return (
    <section id="products" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20 bg-white">
      {/* Section Header */}
      <div className="text-center mb-12 sm:mb-16 lg:mb-20 max-w-3xl mx-auto">
        <div className="text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.15em] text-[#8A8A8A] mb-4 sm:mb-6">
          OUR PRODUCTS
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4 sm:mb-6 px-4">
          Your Daily Discipline Tools
        </h2>
        <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed px-4">
          Designed for both men and women who are committed to better breathing, improved posture, and enhanced facial aesthetics.
        </p>
      </div>

      {/* Products Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-10 lg:gap-12" data-product-shop>
        {products.map((product) => (
          <Link 
            key={product.id}
            to={`/product/${product.id}`} 
            className="group cursor-pointer block"
          >
            <div className="relative aspect-[3/4] bg-[#F8F8F8] rounded-lg overflow-hidden mb-4 sm:mb-5">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover object-[center_20%] group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-black text-white text-[10px] sm:text-xs px-2 sm:px-3 py-1 rounded-full uppercase tracking-wide">
                {product.badge}
              </div>
            </div>
            <div className="px-2 text-center">
              <h3 className="text-base sm:text-lg font-semibold text-black mb-1 sm:mb-2">{product.name}</h3>
              <p className="text-xs sm:text-sm text-[#6B6B6B] mb-3 sm:mb-4">{product.description}</p>
              <div className="flex items-center justify-center gap-4 mb-4">
                <span className="text-lg sm:text-xl font-bold text-black">€{product.price}</span>
              </div>
              <button className="w-full bg-black text-white h-10 sm:h-12 px-6 sm:px-8 rounded-full text-xs sm:text-sm font-medium hover:bg-black/90 transition-colors whitespace-nowrap">
                Shop Now
              </button>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
